import React from 'react'
import { Badge } from '@shared/components/badge'

import styles from './styles.module.scss'

export const data = {
	technologies: {
		heading: 'Технологии',
		content: [
			'Мы знаем, как важно время, комфорт и удобство  для наших клиентов.',
			'Поэтому мы полностью изменили подход  к финансовому сервису и использовали технологии, которые позволили перенести все операции  по займу и инвестированию в онлайн.',
		],
	},

	services: {
		heading: 'Наши сервисы',
		content: [
			'На базе наших технологий мы разрабатываем сервисы для финансовых компаний. ',
			'Это гибкая система, которая состоит из модулей:  их можно подключать все вместе или запускать  по отдельности — зависит от задач организации. ',
		],
	},

	slides: [
		{
			title: 'Модуль привлечения клиентов',
			content: (
				<div>
					<p className={styles.slideContent}>
						Настроенная система лидогенерации с интеграциями в сторонние сервисы и
						автоматизированная аналитика.
					</p>
				</div>
			),
		},
		{
			title: 'Сервис дистанционного обслуживание клиентов',
			content: (
				<div>
					<p className={styles.slideContent}>
						Удобное управление финансами, отслеживание денежных потоков, статистика, электронное
						подписание документов и онлайн-консультации.
					</p>
					<Badge className={styles.slideBadge} theme='wheat'>
						Приложение для инвестора
					</Badge>
					<Badge className={styles.slideBadge} theme='blue'>
						Приложение для заёмщика
					</Badge>
					<Badge className={styles.slideBadge} theme='green'>
						Система управления для менеджера
					</Badge>
				</div>
			),
		},
		{
			title: 'Сервис «Взыскание»',
			content: (
				<div>
					<p className={styles.slideContent}>Помогает в работе с дебиторской задолженностью. </p>
					<Badge className={styles.slideBadge} theme='blue'>
						Приложение «Коллекшн»
					</Badge>
				</div>
			),
		},
		{
			title: 'Сервис оценки заёмщика',
			content: (
				<div>
					<p className={styles.slideContent}>
						Собираем десятки показателей из различных сервисов, проводим аналитику и выявляем
						рейтинг заёмщика.{' '}
					</p>
					<Badge className={styles.slideBadge} theme='blue'>
						Приложение «Риск-менеджмент»
					</Badge>
					<Badge className={styles.slideBadge} theme='green'>
						Модуль «Скоринг»
					</Badge>
				</div>
			),
		},
		{
			title: 'Модуль оценки залога',
			content: (
				<div>
					<p className={styles.slideContent}>
						Умеем узнавать стоимость недвижимости за секунду без участия оценщиков. Автоматическая
						система оценки юридических рисков с формированием отчётов для удобной проверки юристами.
					</p>
					<Badge className={styles.slideBadge} theme='wheat'>
						Приложение для оценщика
					</Badge>
					<Badge className={styles.slideBadge} theme='blue'>
						Оценка недвижимости
					</Badge>
				</div>
			),
		},
		{
			title: 'Сервис доставки финансовых продуктов',
			content: (
				<div>
					<p className={styles.slideContent}>
						Позволяет доставлять финансовые продукты по всей России.
					</p>
					<Badge className={styles.slideBadge} theme='blue'>
						Приложение управления командой представителей{' '}
					</Badge>
					<Badge className={styles.slideBadge} theme='green'>
						Приложение представителя
					</Badge>
				</div>
			),
		},
		{
			title: 'Электронный документооборот',
			content: (
				<div>
					<p className={styles.slideContent}>
						Создаём необходимые договоры через приложение. Подписываем все документы через
						электронно-цифровую подпись в личном кабинете.
					</p>
					<Badge className={styles.slideBadge} theme='wheat'>
						Приложение для ЭДО
					</Badge>
					<Badge className={styles.slideBadge} theme='green'>
						Конструктор договоров
					</Badge>
					<Badge className={styles.slideBadge} theme='blue'>
						Сервис подписания документов
					</Badge>
				</div>
			),
		},
		{
			title: 'Сервис удалённой регистрация через API Росреестра',
			content: (
				<div>
					<p className={styles.slideContent}>
						Регистрируем обременение на недвижимость онлайн через прямую интеграцию с Росреестром.
					</p>
					<Badge className={styles.slideBadge} theme='blue'>
						Прямая интеграция с API Росреестра
					</Badge>
				</div>
			),
		},
		{
			title: 'Сервис «Электронные закладные»',
			content: (
				<div>
					<p className={styles.slideContent}>
						Запустили сервис для быстрой купли-продажи электронных закладных. Сервис полезен для
						профессиональных участников финансового рынка: банков, КПК, МФО и других компаний.
					</p>
					<Badge className={styles.slideBadge} theme='wheat'>
						Приложение выпуска и регистрации электронных закладных
					</Badge>
					<Badge className={styles.slideBadge} theme='blue'>
						Сервис купли-продажи закладных
					</Badge>
					<Badge className={styles.slideBadge} theme='green'>
						Интеграции с финансовыми компаниями
					</Badge>
				</div>
			),
		},
	],
}
